import {Module} from 'vuex';
import ApiService from '../../services/api.service';
import type {RootState} from '..';

export interface SchedulerState {
  templates: any[];
  slots: any[];
  isSlotsLoaded: boolean;
  selectedSlot: any | null;
  selectedPatient: any | null;
  currentOfficeUuid: string | null;
  currentDuration: number | null;
  currentTherapies: Record<string, [string, number, string[]]>; // therapyUUID -> [type, duration, doctorIds]
  profiles: any[];
}

export const scheduler: Module<SchedulerState, RootState> = {
  namespaced: false,
  state: {
    templates: [] as any[],
    slots: [] as any[],
    isSlotsLoaded: false,
    selectedSlot: null,
    selectedPatient: null,
    currentOfficeUuid: null,
    currentDuration: null,
    currentTherapies: {},
    profiles: [],
  },
  getters: {
    templates: (state) => state.templates,
    slots: (state) => state.slots,
    isSlotsLoaded: (state) => state.isSlotsLoaded,
    selectedSlot: (state) => state.selectedSlot,
    selectedPatient: (state) => state.selectedPatient,
    profiles: (state) => state.profiles,
    currentDuration: (state) => state.currentDuration,
    currentTherapies: (state) => state.currentTherapies,
  },
  mutations: {
    setTemplates: (state, { templates }: { templates: any[]}) => {
      state.templates = templates;
    },
    setSlots: (state, { slots, profiles }: { slots: any[], profiles?: any[]}) => {
      state.slots = slots;
      state.isSlotsLoaded = true;
      if (profiles) {
        state.profiles = profiles;
      }
    },
    resetSlots: (state) => {
      state.slots = [];
      state.profiles = [];
    },
    setSelectedSlot: (state, slot: any) => {
      state.selectedSlot = slot;
    },
    setSelectedPatient: (state, patient: any) => {
      state.selectedPatient = patient;
    },
    clearSelectedSlot: (state) => {
      state.selectedSlot = null;
    },
    setCurrentOfficeUuid: (state, uuid: string) => {
      state.currentOfficeUuid = uuid;
    },
    setCurrentDuration: (state, duration: number) => {
      state.currentDuration = duration;
    },
    setCurrentTherapies: (state, therapies: Record<string, [string, number, string[]]>) => {
      state.currentTherapies = therapies;
    },
    setProfiles: (state, profiles: any[]) => {
      state.profiles = profiles;
    },
  },
  actions: {
    async LOAD_LOCATION_TEMPLATES({commit}, payload: { locationUUID: string}) {
      const { locationUUID } = payload;
      try {
        const { data: { templates}} = await ApiService.customRequest({
          method: 'get',
          url: `scheduler/templates/${locationUUID}`,
        });
        commit('setTemplates', { templates });
      } catch (e) {
        // tslint:disable-next-line:no-console
        console.error('LOAD_LOCATION_TEMPLATES ERROR - ', e);
      }

    },
    async SEARCH_SLOTS({commit}, payload) {
      try {
        const { data: { slots, profiles } } = await ApiService.customRequest({
          method: 'post',
          url: `scheduler/search`,
          data: payload,
        });
        commit('setSlots', { slots, profiles });
      } catch (e) {
        // tslint:disable-next-line:no-console
        console.error('SEARCH_SLOTS ERROR - ', e);
      }
    },

  },
};
